export default "__VITE_ASSET__CEPsOI28__"